<template>
  <div>
    <v-card color="grey lighten-5 ma-0 pa-0" :loading="loading">
      <DocumentActionHeader
        :title="$t('DistributionInternalExternal')"
        @on-close-click="onCloseClick"
      />

      <v-card-text class="overflow-y-auto" style="max-height: 250px">
        <template v-for="distribution in distributionList">
          <DistributionItem
            :distribution="distribution"
            v-bind:key="distribution.uuid"
          />
        </template>
        <v-btn @click="endDistribution" color="primary" block>{{ $t("EndDistribution")}}</v-btn>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import DocumentActionHeader from "@/components/search/results/list/item/actions/DocumentActionHeader";
import DistributionItem from "@/components/search/results/list/item/actions/distribution/DistributionItem";
import DocumentService from "@/services/DocumentService";
import Distribution from "@/ecm/models/search/results/list/DistributionItem";

export default {
  name: "DistributionList",
  components: {
    DocumentActionHeader,
    DistributionItem,
  },
  props: {
    documentId: {
      type: Number,
      required: true,
    },
  },
  created() {
    this.loadData();
  },
  data() {
    return {
      distributionList: [],
      loading: false,
    };
  },
  methods: {
    onCloseClick() {
      this.$emit("on-close-click");
    },
    endDistribution() {
      DocumentService.endDistribution(this.documentId).then((data) => {
        this.$emit("on-distribution-ended");
      });
    },
    loadData() {
      this.loading = true;
      DocumentService.getDistributionList(this.documentId).then((data) => {
        this.distributionList = data.map(function (dto) {
          return new Distribution(dto);
        });
        this.loading = false;
      });
    },
  },
};
</script>